import { render, staticRenderFns } from "./SbgCabangJuni.vue?vue&type=template&id=28e41167&scoped=true&"
import script from "./SbgCabangJuni.vue?vue&type=script&lang=js&"
export * from "./SbgCabangJuni.vue?vue&type=script&lang=js&"
import style0 from "./SbgCabangJuni.vue?vue&type=style&index=0&id=28e41167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e41167",
  null
  
)

export default component.exports